import * as types from './reduxTypes'
import axios from 'axios';

const ROOT_URL = 'https://nt0tycan36.execute-api.eu-west-1.amazonaws.com/prod/chefs';

export function fetchChefs() {
  return dispatch => {
    axios.get(ROOT_URL).then(resp => {
      var chefsRequested = [];
      resp.data.Items.forEach((data) => {
        chefsRequested.push({
          name : data.name,
          chefId : data.chefId,
          description : data.description,
          image : data.image,
          blog : data.blog,
          facebook : data.facebook,
          instagram : data.instagram,
          twitter : data.twitter,
          youtube : data.youtube,
          googlePlus : data.googlePlus,
          pinterest : data.pinterest,
          fullImage: data.fullImage, 
          dontShowVideo: data.dontShowVideo
        });
      });

      if (chefsRequested.length > 0) {
        dispatch(seChefs({chefs: chefsRequested}));
      }

    }).catch( (ex) => {
      console.log(ex);
    });
  }
}


//***************************

export function seChefs({ chefs }) {
  return {
    type: types.SET_CHEFS,
    chefs
  }
}



// WEBPACK FOOTER //
// ./src/actions/index.js